var MobileMode = /*#__PURE__*/function (MobileMode) {
  MobileMode["Auto"] = "auto";
  MobileMode["Enable"] = "enable";
  MobileMode["Disable"] = "disable";
  return MobileMode;
}(MobileMode || {});

export { MobileMode as M };
//# sourceMappingURL=MobileMode-DHJ6VHqt.js.map
